import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ZeitenQuerySorterConfig } from 'fa-kt.types';
import { ZeitenService } from '../service';

@Component({
  selector: 'fa-kt-zeiten-sorter',
  templateUrl: './zeiten-sorter.component.html',
  styleUrls: ['./zeiten-sorter.component.css'],
})
export class ZeitenSorterComponent {
  public ZeitenSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public zeiten: ZeitenService,
  ) {
    this.ZeitenSorterConfig = ZeitenQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
